/* eslint-disable no-console */
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';

@Component
export class WindspeedLookup extends ThemeComponent {
    @Ref({ required: true }) button!: HTMLButtonElement;

    init() {
        const event = new Event("openWindspeedPopup");

        this.$listen(this.button, 'click', (e) => {
            e.preventDefault();
            document.dispatchEvent(event);
        });
    }
}
